import { useQuery } from "@tanstack/react-query";
import { getHubRepository } from "@/infrastructure/di";
import { queryKeys } from "../keys";

/**
 * TQ hook for fetching all hub investor profiles.
 * Used by useHubProfile composition hook for server state.
 */
export const useHubProfiles = (options?: { enabled?: boolean }) => {
	return useQuery({
		queryKey: [...queryKeys.hub.profile(), "all"] as const,
		queryFn: () => getHubRepository().getProfiles(),
		enabled: options?.enabled ?? true,
	});
};

export const useHubInvestmentDocuments = (investmentUuid: string) => {
	return useQuery({
		queryKey: queryKeys.hub.investmentDocuments(investmentUuid),
		queryFn: () => getHubRepository().listInvestmentDocuments(investmentUuid),
		enabled: !!investmentUuid,
	});
};
